import React from 'react';
import { ClaimDetail } from "../pages/ClaimItems/models/ClaimDetail.interface";

const isNullOrEmpty = (value: any): boolean => value == null || value.toString() === '' || value === undefined;

export const addProjectCode = (id: string) => {
    const idnum = id.split("SPR");
    const temp = idnum[1].split("_");
    const numberOfSO = parseInt(temp[0], 10);
    const numberOfPage = temp[1];
    const maxRows = 20;

    for (let a = numberOfSO; a <= maxRows; a++) {
        const divPC = document.getElementById(`divPC${a}_${numberOfPage}`);
        if (divPC && divPC.style.display === "none") {
            const txtProjectCode = document.getElementById(`txtProjectCode${a}_${numberOfPage}`);
            const txtPCPercent = document.getElementById(`txtPCPercent${a}_${numberOfPage}`);

            if (txtProjectCode) (txtProjectCode as HTMLInputElement).required = true;
            if (txtPCPercent) (txtPCPercent as HTMLInputElement).required = true;

            divPC.style.display = "block";
            break;
        }
    }

};


export const delProjectCode = (
    id: string,
    handleInputChange: (id: string, value?: any) => Promise<void> //Hazel Amendments 20251106 - Project Code removed field value not update properly, cuz component state not being updated. 
) => {
    const idnum = id.split("SPR");
    const temp = idnum[1].split("_");
    const numberOfSO = parseInt(temp[0], 10);
    const numberOfPage = temp[1];
    const maxRows = 20;

    for (let a = maxRows; a >= 0; a--) {
        if (a === 1) break;

        const divPC = document.getElementById(`divPC${a}_${numberOfPage}`);
        if (divPC && divPC.style.display === "block") {
            const txtProjectCode = document.getElementById(`txtProjectCode${a}_${numberOfPage}`);
            const txtPCPercent = document.getElementById(`txtPCPercent${a}_${numberOfPage}`);

            if (txtProjectCode) {
                (txtProjectCode as HTMLInputElement).required = false;
                (txtProjectCode as HTMLInputElement).value = "";
            }
            if (txtPCPercent) {
                (txtPCPercent as HTMLInputElement).required = false;
                (txtPCPercent as HTMLInputElement).value = "";
            }

            handleInputChange(`txtProjectCode${a}_${numberOfPage}`, "");
            handleInputChange(`txtPCPercent${a}_${numberOfPage}`, "");
            divPC.style.display = "none";
            
            
            break;
        }
    }

};

export const resetProjectCode = (id: string) => {
    for (let a = 1; a <= 20; a++) {
        const divPC = document.getElementById(`divPC${a}_${id}`);
        if (divPC && divPC.style.display === "none") {
            const txtProjectCode = document.getElementById(`txtProjectCode${a}_${id}`);
            const txtPCPercent = document.getElementById(`txtPCPercent${a}_${id}`);

            if (txtProjectCode) (txtProjectCode as HTMLInputElement).value = "";
            if (txtPCPercent) (txtPCPercent as HTMLInputElement).value = "";
        }
    }

};


export const addAPevent = (id: string) => {
    const idnum = id.split("SPR");
    const temp = idnum[1].split("_");
    const numberOfSO = parseInt(temp[0], 10);
    const numberOfPage = temp[1];
    const maxRows = 15;

    for (let a = numberOfSO; a <= maxRows; a++) {
        const divAP = document.getElementById(`divAP${a}_${numberOfPage}`);
        if (divAP && divAP.style.display === "none") {
            const txtAPCeventID = document.getElementById(`txtAPCeventID${a}_${numberOfPage}`);
            const txtAPeventPercent = document.getElementById(`txtAPeventPercent${a}_${numberOfPage}`);

            if (txtAPCeventID) (txtAPCeventID as HTMLInputElement).required = true;
            if (txtAPeventPercent) (txtAPeventPercent as HTMLInputElement).required = true;

            divAP.style.display = "block";
            break;
        }
    }

    const ddlExceedraNoCode1 = document.getElementById('ddlExceedraNoCode1') as HTMLInputElement;
    if (ddlExceedraNoCode1) ddlExceedraNoCode1.dispatchEvent(new Event('change'));

};


export const resetAPevent = (id: string) => {
    for (let a = 1; a <= 15; a++) {
        const divAP = document.getElementById(`divAP${a}_${id}`);
        if (divAP && divAP.style.display === "none") {
            const txtAPCeventID = document.getElementById(`txtAPCeventID${a}_${id}`);
            const txtAPeventPercent = document.getElementById(`txtAPeventPercent${a}_${id}`);

            if (txtAPCeventID) (txtAPCeventID as HTMLInputElement).value = "";
            if (txtAPeventPercent) (txtAPeventPercent as HTMLInputElement).value = "";
        }
    }

};



export const delAPevent = (id: string) => {
    const idnum = id.split("SPR");
    const temp = idnum[1].split("_");
    const numberOfSO = parseInt(temp[0], 10);
    const numberOfPage = temp[1];
    const maxRows = 15;

    for (let a = maxRows; a >= 0; a--) {
        if (a === 1) break;

        const divAP = document.getElementById(`divAP${a}_${numberOfPage}`);
        if (divAP && divAP.style.display === "block") {
            const txtAPCeventID = document.getElementById(`txtAPCeventID${a}_${numberOfPage}`);
            const txtAPeventPercent = document.getElementById(`txtAPeventPercent${a}_${numberOfPage}`);

            if (txtAPCeventID) {
                (txtAPCeventID as HTMLInputElement).required = false;
                (txtAPCeventID as HTMLInputElement).value = "";
            }
            if (txtAPeventPercent) {
                (txtAPeventPercent as HTMLInputElement).required = false;
                (txtAPeventPercent as HTMLInputElement).value = "";
            }

            divAP.style.display = "none";
            break;
        }
    }

};


